import { useTranslation } from '@unifyapps/i18n/client';
import { useSnackbar } from '@unifyapps/ui/components/Snackbar';
import { useCallback } from 'react';

export function useCleverTap() {
  const { t } = useTranslation();
  const { showSnackbar } = useSnackbar();

  // no-op for web
  const recordEvent = useCallback(
    (_args: { event: string; properties: Record<string, string> }) => {
      showSnackbar({
        color: 'warning',
        title: t('common:CleverTapRecordEventNativeOnly'),
      });
    },
    [showSnackbar, t],
  );

  return { recordEvent };
}
